module.exports = __webpack_public_path__ + "img/4.e765d095.jpg";